import React from "react";
import { useTranslation } from "@me8eon/translation";
import styles from "./ImageUploaderTooltipContent.module.scss";
import {Icon} from "@me8eon/icons";

const InfoTooltipContent: React.FC = () => {
    const t = useTranslation();
    return (
        <div className={styles.tooltipText}>
            {t("chatBot.uploadImageTooltip")}
            <br/>
            {t("chatBot.uploadImageFormat")}
        </div>
    );
}

const FilesTooltipContent: React.FC<{
    files: File[], onRemove: (e: React.MouseEvent, file: File) => void
}> = ({files, onRemove}) => {
    return (
        <div className={styles.filesTooltip__container}>
            {files.map((file, index) => (
                <div key={index} className={styles.fileItem}>
                    <p>{file.name}</p>

                    <div className={styles.fileItem__iconButton} onClick={(e) => onRemove(e, file)}>
                        <Icon name="trash_bin"/>
                    </div>
                </div>
            ))}
        </div>
    );
}

type Props = {
    files?: File[],
    onRemove: (e: React.MouseEvent, file: File) => void
}

export const ImageUploaderTooltipContent: React.FC<Props> = ({files, onRemove}) => {

    if (files && files.length > 0) return (
        <FilesTooltipContent files={files ?? []} onRemove={onRemove}/>
    )

    return <InfoTooltipContent/>

}